import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Landing() {
  return (
    <div className="app-shell grain flex flex-col justify-between p-6">
      <header className="pt-10">
        <p className="text-xs tracking-[0.35em] uppercase text-muted-foreground" data-testid="brand-tag">
          Locked · daily language exchange
        </p>
      </header>

      <section className="flex-1 flex flex-col justify-center py-10 animate-fade-up">
        <h1 className="font-serif text-5xl sm:text-6xl leading-[1.02] tracking-tight text-foreground">
          Learn a language<br />
          by <span className="text-primary italic">talking</span> to<br />
          one real person.
        </h1>
        <p className="mt-8 text-base leading-relaxed text-muted-foreground max-w-md">
          Every day we pair you with one native speaker of the language you're learning —
          who is learning yours. No swiping, no feed, no choice. Just 24 hours to actually talk.
        </p>

        <div className="mt-12 space-y-3">
          <p className="text-sm text-muted-foreground italic">How it works</p>
          <ul className="space-y-2 text-base">
            <li className="flex gap-3"><span className="text-primary">·</span> Pick your native language and the one you're learning.</li>
            <li className="flex gap-3"><span className="text-primary">·</span> Every day, one perfect exchange partner appears.</li>
            <li className="flex gap-3"><span className="text-primary">·</span> Talk for 24 hours. Half in your language, half in theirs.</li>
            <li className="flex gap-3"><span className="text-primary">·</span> If it clicked, you both choose to stay in touch.</li>
          </ul>
        </div>
      </section>

      <footer className="pb-8 space-y-3">
        <Link to="/register" className="block">
          <Button
            data-testid="cta-get-started"
            className="w-full h-14 rounded-full text-base font-medium bg-primary hover:bg-primary/90 text-primary-foreground transition-transform hover:-translate-y-0.5"
          >
            Get my first exchange partner
          </Button>
        </Link>
        <Link
          to="/login"
          data-testid="cta-login"
          className="block text-center text-sm text-muted-foreground hover:text-foreground transition-colors py-3"
        >
          I already have an account
        </Link>
      </footer>
    </div>
  );
}
